import React from "react";
import { useParams } from "react-router-dom";
import ClientSetupForm from "./client-setup-form";

function ClientSetupContainer() {
  const { id } = useParams();

  const clientId = React.useMemo(() => {
    if (id) {
      return id;
    }
    return "new";
  }, [id]);

  return <ClientSetupForm clientId={clientId} />;
}

export default ClientSetupContainer;
